export class GradientColors {
  static readonly SUCCESS_COLOR = '#44bb37';
  static readonly WARNING_COLOR = '#ffaa00';
  static readonly DANGER_COLOR = '#ff3d71';
}
